/**
 * Created by Boris on 15/02/2017.
 */
export class AddressDetails {
  streetNumber: string;
  street: string;
  streetType: string;
  streetTypeId: number;
  streetSuffixType: string;
  streetSuffixTypeId: number;
  state: string;
  suburb: string;
  postCode: string;
  unitNumber: string;
  unitType:string
  floorType:string
  floorNumber:string
  unitTypeId?:number
  floorTypeId?:number

  toUpperCase() {

    if (this.streetNumber) {
      this.streetNumber = this.streetNumber.toUpperCase();
    }

    if (this.street) {
      this.street = this.street.toUpperCase();
    }

    if (this.streetType) {
      this.streetType = this.streetType.toUpperCase();
    }

    if (this.streetSuffixType) {
      this.streetSuffixType = this.streetSuffixType.toUpperCase();
    }

    if (this.state) {
      this.state = this.state.toUpperCase();
    }

    if (this.suburb) {
      this.suburb = this.suburb.toUpperCase();
    }
  }

  copy(address: AddressDetails) {
    this.streetNumber = address.streetNumber;
    this.street = address.street;
    this.streetType = address.streetType;
    this.streetTypeId = address.streetTypeId;
    this.streetSuffixType = address.streetSuffixType;
    this.streetSuffixTypeId = address.streetSuffixTypeId;
    this.state = address.state;
    this.suburb = address.suburb;
    this.postCode = address.postCode;
     this.unitNumber = address.unitNumber;
   }

  clear() {
    this.streetNumber = '';
    this.street = '';
    this.streetType = '';
    this.streetTypeId = -1;
    this.streetSuffixType = '';
    this.streetSuffixTypeId = -1;
    this.state = '';
    this.suburb = '';
    this.postCode = '';
    this.unitNumber = '';
   }
}



// WEBPACK FOOTER //
// ./src/app/shared/data-objects/address-details.ts